import { useEffect, useState } from 'react'
import { Row, Col, Button, Modal, Pagination, Card, OverlayTrigger, Tooltip, Spinner, Form } from 'react-bootstrap'
import data, { configs3 } from '../../../../lib/backend/data'
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton'
import { confirmAlert } from 'react-confirm-alert'
import S3FileUpload from "react-s3/lib/ReactS3"
import { useDispatch, useSelector } from 'react-redux';
import { url_images } from '../../../../lib/global/data';
import { cerrarSesion } from '../../../../redux/actions/session';

const WoocommercePluginConfig = (props) => {
    const [ conductores, setConductores ] = useState([])
    const [ creando, setCreando ] = useState(false)
    const [ nuevaKey, setNuevaKey ] = useState({})
    const [ openModal, setOpenModal ] = useState(false)
    const [ loading, setLoading ] = useState(true)
    const [ testing, setTesting ] = useState(false)
    const [ showModal, setShowModal ] = useState(false)
    const session = useSelector(state => state.miusuario)
    const [ config, setConfig ] = useState({ tipo: 'importador', sub_tipo: 'woocommerce_config', descripcion: "Woocommerce", nombre: "v1", detalles: {} })
    const [ keyCreada, setKeyCreada ] = useState(false)
    const dispatch = useDispatch()
    const token = session.tokenSession

    const regrescarConexion = async () => {
        if(!config._id) return toast.error("Debes guardar primero tus credenciales")
        setTesting(true)
        return fetch(`${data.urlapi}/integraciones/plugin/conectar?id=${config._id}`, {
            method:'GET',
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
                toast.error('Sin datos')
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
            } else if(res.message){
                toast.info(res.message)
            }
            return setTesting(false)
        })
        .catch(error => {
            console.log(error.message)
            toast.error("Error al consultar la información, intente nuevamente")
            return setTesting(false)
        })

    }

    const guardarCambios = async () => {
        const requeridos = []
        let faltantes = []
        requeridos.map(campo => {
            if(!config[campo.value]) faltantes.push(campo.label)
            return true
        })
        if(faltantes.length > 0) return toast.error(`Faltan campos: ${faltantes.join(', ')}`)
        setCreando(true)
        return fetch(`${data.urlapi}/integraciones/plugin`, {
            method:'PUT',
            body: JSON.stringify(config),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            setCreando(false)
            if(!res){
                toast.error('Sin datos')
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
            } else if(res._id){
                toast.success("Actualizado exitosamente")
                setConfig(res)
            }
            return setLoading(false)
        })
        .catch(error => {
            setCreando(false)
            toast.error("Error al consultar la información, intente nuevamente")
            return setLoading(false)
        })

    }

    const obtenerConfig = async () => {
        return fetch(`${data.urlapi}/integraciones/plugin?tipo=${config.tipo}&subtipo=${config.sub_tipo}`,{
            method:'GET',
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
            } else if(res.errorMessage){
            } else if(res._id){
                if(!res.detalles) res.detalles = {}
                setConfig(prev => ({...prev, ...res}))
            }
            return setLoading(false)
        })
        .catch(error => {
            toast.error("Error al consultar la información, intente nuevamente")
            return setLoading(false)
        })
    }

    const handleClose = () => {
        setShowModal(false)
    }

    const handleChange = (e) => {
        const { name, value } = e.target
        config[name] = value
        console.log(config)
        return setConfig(config)
    }
    
    const handleChangeObject = (e) => {
        const { name, value } = e.target
        if(!config.detalles) config.detalles = {}
        config.detalles[name] = value
        console.log(config)
        return setConfig(config)
    }

    const mostrarFormulario = () => {
        if(loading) return cargandoScreen()
        return <div>
            <Row>
                <Col xs={12} className="mb-2">
                <OverlayTrigger
                            placement={'top'}
                            overlay={
                              <Tooltip>Ejemplo: https://mipagina.com </Tooltip>
                            }
                            >
                    <div>
                    <label className='d-block form-control-label'>Sitio web</label>
                    <input className='form-control' name="web" defaultValue={config.detalles.web} onChange={handleChangeObject} />
                    </div>
                    </OverlayTrigger>
                </Col>
                <Col xs={6} className="mb-2">
                    <label className='d-block form-control-label'>Clave de cliente</label>
                    <input className='form-control' name="consumer_key" defaultValue={config.detalles.consumer_key} onChange={handleChangeObject} />
                </Col>
                <Col xs={6} className="mb-2">
                    <label className='d-block form-control-label'>Clave secreta</label>
                    <input className='form-control' name="consumer_secret" defaultValue={config.detalles.consumer_secret} onChange={handleChangeObject} />
                </Col>
                <Col xs={6} className="mb-2">

                </Col>
                <Col md={12}>
                    { testing === true ? <Spinner animation='border' /> : <Button size="sm" variant="outline-primary" onClick={() => regrescarConexion()}>PROBAR/REFRESCAR CONEXIÓN</Button> }
                    <hr className='hr' />
                    { creando === true ? <Spinner animation='border' /> : <Button size="sm" variant="success" onClick={() => guardarCambios()}>GUARDAR CAMBIOS</Button> }
                </Col>
            </Row>
        </div>
    }
    const modalFiltro = () => {

        return <Modal show={showModal} size="lg" onHide={handleClose}
        centered
        >
        <Modal.Header closeButton>
          <Modal.Title>Configuración de Woocommerce</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {mostrarFormulario()}
        </Modal.Body>
        
      </Modal>
    }


    useEffect(() => {
        obtenerConfig()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const cargandoScreen = () => {
        return <Row>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
                <Col md={12} className="mb-3"><Skeleton height={40} /></Col>
            </Row>
    }

    return <Card className='p-2 mb-3 text-center centrador' style={{ minHeight: 130 }} >
        {modalFiltro()}
        <img alt="WOOCOMMERCE" onClick={() => setShowModal(true)} src={`${url_images}/woocommerce.png`} style={{ maxHeight: 100, maxWidth: "70%", margin: "0 auto" }} /> 
    </Card>

}

export default WoocommercePluginConfig